import React, { useEffect, useState, useMemo } from "react";
import CustomButton from "../../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
    settheTicketsystemrecordgetListDataActions,
    setTheoptions,
    setThecountBasedRenders,
    setTheTrackingDeleteActions,
    setTheTrackingEditionsActions,
    setTheTicketingsystemStatusState,
    setTheTicketingsystemtRange1,

    setTheTicketingsystemRange2,
    settheTicketingDashboardActions,
    settheTicketIDSActions, setthePriorityStatus,
    setGeoLoactionStateAction,
    setZoneActions,
    setRegionActions,
    setClientBranchSearchAction,

    setTheTicketSystemlistZoneObject,
    setTheTicketSystemlistRegionObject,
    setTheTicketSystemListStateObject,

    setTheTicketSystemlistBranchObject,
    settheroutesforticketAssignsViews,


    settheTicketraiseroutes,
    settheTicketSuccesspopuos, // success popup
    setTablePositionPersist
} from "../../../../Redux/Slice";
import { NavLink, useNavigate } from "react-router-dom";
import ReactTable from "../../../AppComponent/Table";
import Select from "react-select";
import Delete from "../../../AppComponent/Popup/Delete";
import Search from "@mui/icons-material/Search";
import AccessAlarmIcon from "@mui/icons-material/AccessAlarm";
import { parseISO, addDays, differenceInDays } from "date-fns";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import { Chart } from "react-google-charts";
import Swal from "sweetalert2";
import _ from "lodash";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeclineIcon from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-31.svg";
import PendignIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-32.svg";
import EmployeeIcons from "../../../../Assets/MainComponent/DashboardIcons/UDS MEDIA ASSETS-33.svg";

import high from "../../../../Assets/AppComponent/Group 427319195.svg";
import low from "../../../../Assets/AppComponent/Group 427319196.svg";
import medimum from "../../../../Assets/AppComponent/Group 427319197.svg";
import useDebouncedEffect from 'use-debounced-effect';



const TicketingList = () => {
    const dispatch = useDispatch();
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );

    const state = useSelector((state) => state);
    const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
    const [newpages, setNewpage] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
  const TablePositionPersist = useSelector(
        (state) => state.PreviousPagePosition.TablePositionPersist
      )
    
  const [dtpageindex, setdtPageindex] = useState(
        TablePositionPersist?.Ticketing_listed?.page == undefined
          ? 1
          : TablePositionPersist.Ticketing_listed.page
      ); 
  const [search, setsearch] = useState(
        TablePositionPersist?.Ticketing_listed?.search == undefined ||
        TablePositionPersist?.Ticketing_listed?.search ==""
          ? ""
          : TablePositionPersist.Ticketing_listed.search
      ); 

    const [dtpagesize, setdtPagesize] = useState(20);
    const [pageSize, setPageSize] = useState(20);
    const [DeletePOPUP, setDeletePOPUP] = useState(false);
    const [DeleteID, setDeleteID] = useState("");
    const [EditId, setEditID] = useState();
    const navigate = useNavigate()
    const FileterState = {
        status: state.StateManagementOverallCall.TicketingsysttemStatusState?.value,
        // status: "0",
        priority: state.StateManagementOverallCall.TicketPriorityStatus?.value,
    };
    const [selectDisplay, setDisplay] = useState([]);

    const [selectVal, SetSelectval] = useState(FileterState);

    const [StatusTicket, setstatustcket] = useState({
        value: state.StateManagementOverallCall.TicketingsysttemStatusState?.value, label: state.StateManagementOverallCall.TicketingsysttemStatusState?.label
    })

    //  const [StatusTicket , setstatustcket] = useState({value:"0", label:"Open"})
    const [FState, SetStates] = useState(false);

    const [FindZeroticket, setFindZeroTickets] = useState(false);
    const [CountFroActions, setCountForActions] = useState(0);
    // Define state to manage checkbox selections, if needed
    const [selectedIds, setSelectedIds] = useState([]);
    const [checked, setchecked] = useState(false);
    const formDatas = new FormData();

    const [ListedIds, setlistedids] = useState([]);

    console.log(state.StateManagementOverallCall.TicketingsysttemStatusState ,"state.StateManagementOverallCall.TicketsStatusState");

    ////--_FIlter--------------------------
    const [Filter, SetFilter] = useState(true);
    const [TracketReport, setTicketReport] = useState({
        OpenTicket: 2,
        Closeticker: 3,
        PendingTickets: 4,
    });

    const optionsstatus = [
        { value: "", label: "All" },

        { value: "0", label: "Open" },
        { value: "1", label: "In Progress" },
        { value: "2", label: "Review" },
        { value: "over_due", label: "Over Due" },
        { value: "3", label: "Resolved" },

        { value: "4", label: "Reopened" },
    ];

    const priorityoptions = [
        {
            value: "",
            label: "All"
        },
        {
            value: "0",
            label: "Low"
        },
        {
            value: "1",
            label: "Medium"

        },
        {
            value: "2",
            label: "High"

        }
    ];
    const [PriorityValues, setPriorityValues] = useState(state.StateManagementOverallCall.TicketPriorityStatus)
    const [mulitibranch, setMulibranch] = useState([state.ClientBranchIDs.TicketSystem_List_Branch]);
    const [Searchbranch, setsearchbranch] = useState("");

    const [Optionsbranch, setOptionsbranch] = useState([]);




    const [multiselect1, setMuliselect1] = useState([state.ClientBranchIDs.TicketSystem_List_Region,]);
    const [multiselect3, setMuliselect3] = useState([state.ClientBranchIDs.TicketSystem_List_Zone,]);
    const [nameList5, setOptions5] = useState([]);
    const [Zone, setZone] = useState([]);

    const [Clientid, setclientid] = useState(state.ClientBranchIDs?.TicketSystem_List_Branch?.value)
    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.TicketSystem_List_Zone?.value,
        state: state.ClientBranchIDs.TicketSystem_list_State?.value,
        region: state.ClientBranchIDs.TicketSystem_List_Region?.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.TicketSystem_list_State,]);
    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [REgion, setRegion] = useState([]);
    let Ids = [];
    const [nameList4, setOptions4] = useState([]);


    ///----Filter-----------------------

    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);

    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
        Clientsearch:""
    };
    
    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);
    

    const [place, SetPlace] = useState("All");
    const [sel, setSelected] = useState();
    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(state.StateManagementOverallCall.TicketingsystemRange1);
    var gt = convert(state.StateManagementOverallCall.TicketingsystemRange2);
    var startweet = convert(startOfWeek(new Date()));
    var endweek = convert(endOfWeek(new Date()))
    const [range, setrange] = useState(
        state.StateManagementOverallCall.TicketingsystemRange1 == ""
            ? // [it, gt]
            [startweet, endweek]
            : [it, gt]
    );
    const handlechangedate = (value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
        }
    };
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(setTheTicketingsystemtRange1(range[0]));
            dispatch(setTheTicketingsystemRange2(range[1]));
        }
    }, [range]);

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }

    const pagesize = (arg) => {
        setdtPagesize(arg);
    };
    const pageindex = (arg) => {
        //  console.log(arg, "args");
        setdtPageindex(arg);
    };

    const [yearAndMonth, setYearMpnth] = useState();
    const date = new Date();
    const months =
        date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    const displaydate =
        date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    const YearList = date.getFullYear();
    //var yearAndMonth = `${date.getFullYear()}-${months}`;
    useEffect(() => {
        setYearMpnth(`${date.getFullYear()}-${months}`);
    }, []);
    const [Datestate, setdata] = useState({
        date: displaydate,
        month: months,
        year: YearList,
    });


    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            const payload = {
                search: search,
                page_size: dtpagesize,
                page: dtpageindex,
                from_date: range[0],
                to_date: range[1],
                range: true,
                status: selectVal.status == "over_due" ? "" : selectVal.status,
                priority: selectVal.priority,
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                client: Clientid,
                ticket_type: "external",
                ticket_assign: true,
                over_due: selectVal.status == "over_due" ? true : ""



                // udsuser: state.SideBarFiles.LoginIDs
            };
            dispatch(settheTicketsystemrecordgetListDataActions(payload));


                   dispatch(
                                  setTablePositionPersist({
                                    data: payload,
                                    pageName: "Ticketing_listed",
                                  })
                                );
                    
        }
    }, [dtpageindex, dtpagesize, range, selectVal.status, selectVal.priority, search, datas, Clientid]);

    // useEffect(() => {
    //     // const payloads = {
    //     //     // udsuser: state.SideBarFiles.LoginIDs
    //     //     from_date: range[0],
    //     //     to_date: range[1],
    //     //     range: true,
    //     // }

    //     dispatch(settheTicketingDashboardActions())
    // }, [])

    console.log(state.StateManagementOverallCall.TicketPriorityStatus, selectVal, "aspduaps dapsoud TicketingsystemRange1", state.StateManagementOverallCall.TicketingsysttemStatusState);



    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------_Zone---------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
        setZone(state.ZonePart.Zone);
    }, [datas.region, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1, //-----only we ----get----the----selected regions , the--id only
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);



    useEffect(() => {
        // if(datas.state !="" && datas.region !="" && datas.zone !=""){ 
        const payload = {
            search: Searchbranch,
            page_size: 20,
            page: 1,
            data: datas,
        };
        setTimeout(() => {
            dispatch(setClientBranchSearchAction(payload));
        }, 400);
    }, [Searchbranch, datas]);

    const HandleInputBranch = (e) => {
        setSearchDebounance({
          ...SearchDebounance,
          Clientsearch:e
        
        })  };
        
        

    useEffect(() => {
        if (state.BranchSearchpart.BranchSearch != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.BranchSearchpart.BranchSearch.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });
            setOptionsbranch(objectArray);
        }
    }, [state.BranchSearchpart.BranchSearch, Searchbranch]);


    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
            });

            // console.log(objectArray , "objectArray");
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);


    useEffect(() => {
        if (state.BranchSearchpart.BranchSearch != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.BranchSearchpart.BranchSearch.forEach((element) => {
                objectArray.push({
                    value: element.id,
                    label: element.client_name.toUpperCase(),
                });
            });
            setOptions4(objectArray);
        }
    }, [state.BranchSearchpart.BranchSearch, search]);


    ///  ///----------------------REgion-----------
    useEffect(() => {
        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
            });

            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);


    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "ALL" });

            setData({
                ...datas,
                region: selectedVal.value,
            });
            dispatch(setTheTicketSystemlistRegionObject(selectedVal));

            dispatch(setTheTicketSystemlistZoneObject({ value: "", label: "ALL" }));

        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });
            dispatch(setTheTicketSystemlistRegionObject({ value: "", label: "ALL" }));

            dispatch(setTheTicketSystemlistZoneObject({ value: "", label: "ALL" }));


            setMuliselect3({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
        }
    };
    //----------------Zone
    const handleZone = (selectedVal) => {
        //console.log(selectedVal ,"selected Values");
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });
            dispatch(setTheTicketSystemlistZoneObject(selectedVal));
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });
            dispatch(setTheTicketSystemlistZoneObject({ value: "", label: "ALL" }));
            setMuliselect3({ value: "", label: "ALL" });
        }
    };
    const handleSelectChange = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });

            setData({
                ...datas,
                state: selectedVal.value,
                zone: "",
                region: "",
            });


            dispatch(setTheTicketSystemListStateObject(selectedVal));



        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });

            dispatch(setTheTicketSystemListStateObject({ value: "", label: "ALL" }));

        }
        dispatch(setTheTicketSystemlistBranchObject({ value: "", label: "ALL" }));

        dispatch(setTheTicketSystemlistRegionObject({ value: "", label: "ALL" }));

        dispatch(setTheTicketSystemlistZoneObject({ value: "", label: "ALL" }));
        // dispatch(setTheTicketSystemBranchObject({ value: "", label: "ALL" }));

        setMulibranch([])
        setclientid("")
    };
    ///-------------Zone--------------
    useEffect(() => {
        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);



    useEffect(() => {
        if (state.TrackingrecordgetList.TrackingReport) {
            const Options = {
                OpenTicket:
                    state.TrackingrecordgetList.TrackingReport.open_tracking_count,
                Closeticker:
                    state.TrackingrecordgetList.TrackingReport.close_tracking_count,
                PendingTickets:
                    state.TrackingrecordgetList.TrackingReport.pending_tracking_count,
            };
            setTicketReport(Options);
        }
    }, [state.TrackingrecordgetList.TrackingReport]);



    useEffect(() => {
        if (state.TrackingrecordgetList.TrackingReport != null

        ) {
            if (
                state.TrackingrecordgetList.TrackingReport.open_tracking_count == 0 &&
                state.TrackingrecordgetList.TrackingReport.close_tracking_count == 0 &&
                state.TrackingrecordgetList.TrackingReport.pending_tracking_count == 0
            ) {

                setFindZeroTickets(false);

            } else if (
                state.TrackingrecordgetList.TrackingReport.open_tracking_count != 0 ||
                state.TrackingrecordgetList.TrackingReport.close_tracking_count != 0 ||
                state.TrackingrecordgetList.TrackingReport.pending_tracking_count != 0
            ) {

                setFindZeroTickets(true);
            }

        }

    }, [state.TrackingrecordgetList.TrackingReport]);
    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };

    const cleaningrange = () => {
        //setrange([gt,it]);
    };
    const HandlethepriorityChanges = (e) => {
 if(e != null){
            dispatch(setthePriorityStatus(e))
        setPriorityValues(e);
        SetSelectval({
            ...selectVal,
            priority: e.value
        })
 }
 else{
            dispatch(setthePriorityStatus([]))
        setPriorityValues(null);
        SetSelectval({
            ...selectVal,
            priority: ""
        })
 }
    }

    const HandleClientBranches = (values) => {

        if (values != "") {
            setMulibranch(values)
            setclientid(values.value)
            dispatch(setTheTicketSystemlistBranchObject(values));

        }
        else {
            setMulibranch([])
            setclientid("")
            dispatch(setTheTicketSystemlistBranchObject({ value: "", label: "ALL" }));
        }
    }

    console.log(state.StateManagementOverallCall.TicketingsystemRange1, "StateManagementOverallCall.TicketingsystemRange1");


    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last week",
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },
    ];

    const handleHeaderCheckboxChange = (e) => {
        // console.log(ListedIds, "ListedIds", e);

        if (e) {
            setchecked(true);
            setSelectedIds(ListedIds);
        } else {
            setSelectedIds([]);
            setchecked(false);
        }
    };

    // Function to handle checkbox change
    const handleCheckboxChange = (id) => {
        // Check if the id is already in the selectedIds array
        const isSelected = selectedIds.includes(id);

        if (isSelected) {
            // If id is already selected, remove it from the array
            const updatedIds = selectedIds.filter((selectedId) => selectedId !== id);
            setSelectedIds(updatedIds);
        } else {
            // If id is not selected, add it to the array
            setSelectedIds([...selectedIds, id]);
        }

    };

    const handleChangesOfMulti = () => {
        // Display SweetAlert with custom HTML content
        Swal.fire({
            title: "Select Options",
            html: `
          <div style="display: flex; flex-direction: row; align-items: start;gap:20px">
          <label for="approve" style="margin-bottom: 10px;">
  
            <input type="checkbox" id="approve" name="option" value="close">
            Close</label>
              <label for="decline" style="margin-bottom: 10px;">
            <input type="checkbox" id="decline" name="option" value="open">
             Open</label>
             <label for="pending" style="margin-bottom: 10px;">
            <input type="checkbox" id="pending" name="option" value="pending">
           Pending</label>
            
  
          </div>
  
          <div id="reasonInputContainer" style="display: none; margin-top: 10px; width: 100%;">
          <label for="reasonInput" style="text-align:left;width:100%">Reason for Decline:</label>
          <input placeholder="Reason for Decline" type="text" id="reasonInput" name="reasonInput" style="width: 100%; box-sizing: border-box; padding:10px">
        </div>
        
  
        `,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#F05839",
            cancelButtonColor: "#F37738",
            confirmButtonText: "Yes, proceed!",
        }).then((result) => {
            if (result.isConfirmed) {
                // Retrieve selected options
                const selectedOptions = [];
                const checkboxes = document.querySelectorAll(
                    'input[name="option"]:checked'
                );

                checkboxes.forEach((checkbox) => {
                    selectedOptions.push(checkbox.value);
                });

                // Check if "Decline" was selected and get the reason input
                const isDeclined = selectedOptions.includes("decline");
                const reasonInput = document.getElementById("reasonInput").value;

                if (isDeclined && reasonInput.trim() === "") {
                    // If "Decline" was selected but reason input is empty
                    Swal.fire("Please provide a reason for decline", "", "error");
                    return; // Exit function without proceeding
                }

                // Perform actions based on selected options
                console.log("Selected options:", selectedOptions);
                if (isDeclined) {
                    console.log("Reason for decline:", reasonInput);
                }
                formDatas.append(
                    "data",
                    JSON.stringify({
                        status: "close",
                        request_type: "request",
                        reason_for_decline: reasonInput,
                    })
                );

                const payload = {
                    status: "close",
                    reason_for_decline: reasonInput,
                    currentPage: currentPage,
                    selectVal: selectVal,
                    // month: Data.month,
                    // year: Data.year,

                    formDatas: formDatas,
                    from_date: range[0],

                    to_date: range[1],

                    EditID: JSON.stringify(selectedIds),
                };

                dispatch(setTheTrackingEditionsActions(payload));
                setSelectedIds([]);
                setchecked(false);
                // Show success message using SweetAlert
            } else {
                // User cancelled, show a message or perform other actions
                console.log("User cancelled the changes.");
                Swal.fire("Cancelled", "Your changes have not been applied.", "info");
            }
        });

        // Add event listener to show/hide reason input based on "Decline" checkbox
        const declineCheckbox = document.getElementById("decline");
        const reasonInputContainer = document.getElementById(
            "reasonInputContainer"
        );

        declineCheckbox.addEventListener("change", () => {
            reasonInputContainer.style.display = declineCheckbox.checked
                ? "block"
                : "none";
        });
    };

    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });
               setsearchbranch(SearchDebounance.Clientsearch)
            }
        },
        500,
        [SearchDebounance]
    );
    
    ///-----State----Input Changes
    const handleInputChange = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            stateSearch: Val,
    
        });
    
    };
    
    ///---Region-----------------
    const handleInputRegion = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            regionSearch: Val,
        });
    };
    ///----Zone---Name
    const handleInputZone = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            zoneSearch: Val,
        });
    };
    

    function tochange(e) {
        setdtPageindex(1);
        debouncedSearch(e);

    }
    const debouncedSearch = useMemo(
        () =>
            _.debounce((e) => {
                setsearch(e);
            }, 500),
        []
    );
    React.useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);


    const calculateDateDifference = (createdAt, expireDate) => {
        const createdDate = Date.parse(createdAt);
        const expireDateObj = Date.parse(expireDate);

        if (isNaN(createdDate) || isNaN(expireDateObj)) {
            console.error("Invalid date format:", { createdAt, expireDate });
            return NaN;
        }

        const differenceInTime = expireDateObj - createdDate;
        const differenceInDays = Math.ceil(
            differenceInTime / (1000 * 60 * 60 * 24)
        );
        return differenceInDays;
    };

    const getIconColor = (createdAt, expireTime) => {
        // Convert expireTime to an integer
        const expireDays = parseInt(3);

        // Calculate the expiration date by adding expireDays to createdAt
        const expirationDate = addDays(createdAt, expireDays);

        // Calculate the difference in days between expiration date and current date
        const daysDifference = differenceInDays(expirationDate, new Date());

        // Log the difference in days for debugging
        console.log(daysDifference, "daysDifference", expirationDate, expireDays);

        // Determine the color based on the difference in days
        if (daysDifference < 0 || daysDifference == 0) {
            return "red"; // Expired, set color to red
        }
        // else if (daysDifference <= 2) {
        else if (daysDifference == 2) {
            // return "yellow"; // Expiring within 7 days, set color to yellow
            return "green";
        } else if (daysDifference == 1) {
            return "red"; // Not expiring soon, set color to green
        }
    };



    const capitalizeEachWord = (str) => {
        return str
            .split(' ') // Split the string into an array of words
            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
            .join(' '); // Join the words back into a string
    };

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) {
            return text;
        }
        return text.substring(0, maxLength) + "...";
    };

    const formatedDateListwithouttime = (dateString) => {
        const date = new Date(dateString);

        // Options for date formatting (only date)
        const dateOptions = {
            month: "short", // e.g., Dec
            day: "2-digit", // e.g., 22
            year: "numeric", // e.g., 2024
        };

        // Options for time formatting (only time)
        const timeOptions = {
            hour: "2-digit", // e.g., 02
            minute: "2-digit", // e.g., 16
            hour12: true, // e.g., AM/PM format
        };

        // Format the date and time separately
        const formattedDate = date.toLocaleDateString("en-US", dateOptions);
        const formattedTime = date.toLocaleTimeString("en-US", timeOptions);

        // Combine the formatted date and time
        return `${formattedDate}`;
    };


    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);

        const day = String(dateObject.getDate()).padStart(2, '0');
        const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
        const year = dateObject.getFullYear();

        return `${day} / ${month} / ${year}`;
    };




    const columns = [
        {
            Header: "Ticket Number",
            accessor: "",
            Cell: ({ row }) => {
                const userId = row.original.id;
                const lastFourDigits = userId ? userId.toString().slice(-6) : "---";
                const originalString = row.original.status;
                const ticketnum = row.original.ticket_number;

                const createdAt = row.original.created_at
                    ? parseISO(row.original.created_at)
                    : null;
                const expireTime = row.original.sub_category_id?.TAT
                    ? row.original.sub_category_id.TAT
                    : null;
                // const expireTime = true ? 3 : null;
                const iconColor =
                    createdAt && expireTime
                        ? getIconColor(createdAt, expireTime)
                        : "grey"; // Default color if dates are not available

                return (
                    <>
                        {userId ? (
                            <span
                                style={{ display: "flex", gap: "10px", alignItems: "center", justifyContent: "center", width: "107px" }}
                            >
                                {/* {originalString.toLowerCase() != "close" &&
                                    createdAt &&
                                    expireTime ? (
                                    <AccessAlarmIcon style={{ color: iconColor }} />
                                ) : (
                                    <>
                                        {originalString.toLowerCase() == "close" ? (
                                            <AccessAlarmIcon style={{ color: "green" }} />
                                        ) : null}
                                    </>
                                )} */}

                                {ticketnum}

                            </span>
                        ) : (
                            <span>---</span>
                        )}
                    </>
                );
            },
        },
        // {
        //     Header: "Ticket Number",
        //     accessor: "",
        //     Cell: ({ cell }) => {
        //         let data = cell.row.original;
        //         return (
        //             <div className="listTurfImgCell">
        //                 <p> {data.ticket_number}</p>
        //             </div>
        //         );
        //     },
        // },
        {
            Header: "Client",
            accessor: "",
            Cell: (row) => {
                const [showTooltip, setShowTooltip] = useState(false);

                return (
                    <>
                        {row.row.original.client_id != null &&
                            row.row.original.client_id != undefined &&
                            row.row.original.client_id.client_name != "" &&
                            row.row.original.client_id.client_name != undefined ? (
                            <div className="UserName"
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                                style={{ position: 'relative' }}
                            >
                                <span>
                                    {row.row.original.client_id.client_name.length > 12 ? (
                                        <>
                                            {row.row.original.client_id.client_name.slice(0, 12)}...
                                        </>
                                    ) : (
                                        <>{row.row.original.client_id.client_name}</>
                                    )}
                                </span>

                                {/* Custom tooltip */}
                                {showTooltip && (
                                    <div className="custom-tooltip">
                                        {row.row.original.client_id.client_name}
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="UserName">
                                <span>---</span>
                            </div>
                        )}
                    </>
                );
            },
        },


        {
            Header: "Created Date",
            accessor: "created_at",
            Cell: (row) => {
                const dateString = row.row.original.created_at;
                const dateObject = new Date(dateString);
                const hours = dateObject.getHours();
                const minutes = dateObject.getMinutes();
                const seconds = dateObject.getSeconds();
                const amOrPm = hours >= 12 ? "PM" : "AM";
                const twelveHourFormat = hours % 12 || 12;

                const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

                const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

                return (
                    <>
                        <div className="CreatedDatelisted">
                            {/* {`${row.row.original.created_at.slice(0, 10)}`} */}
                            {row.row.original.created_at ? formatedDateListwithouttime(row.row.original.created_at) : ""}
                            {/* <p> {formatDate(row.row.original.created_at)}</p> */}

                        </div>
                    </>
                );
            },
            // sortType: (rowA, rowB, columnId) => {
            //     const dateA = new Date(rowA.values[columnId]);
            //     const dateB = new Date(rowB.values[columnId]);
            //     if (isNaN(dateA.getTime())) return 1;
            //     if (isNaN(dateB.getTime())) return -1;
            //     return dateA.getTime() - dateB.getTime();
            // },
            // disableSortBy: false,
            // sortType: (a, b) => {
            //     const dateA = new Date(a);
            //     const dateB = new Date(b);
            //     if (isNaN(dateA.getTime())) return 1;
            //     if (isNaN(dateB.getTime())) return -1;
            //     return dateA.getTime() - dateB.getTime();
            // },
            // disableSortBy: false,
        },


        {
            Header: "Category",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.clientsub_category_id?.issue_id?.name ?
                            capitalizeEachWord(data.clientsub_category_id?.issue_id?.name.toLowerCase()) :
                            "-"

                        }</p>
                    </div>
                );
            },
        },
        {
            Header: "Subcategory",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p> {data.clientsub_category_id?.name ?
                            capitalizeEachWord(data.clientsub_category_id?.name.toLowerCase()) : "-"}</p>
                    </div>
                );
            },
        },

        {
            Header: "Description",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="ParaTickets">
                        <p
                        //  data-tooltip-id="my-tooltip" data-tooltip-content={data.remarks} 
                        >{data.remarks ? truncateText(capitalizeEachWord(data.remarks.toLowerCase()), 60) : "-"}</p>

                        {/* <p> {data.remarks ? capitalizeEachWord(data.remarks.toLowerCase()) : "-"}</p> */}
                    </div>
                );
            },
        },




        {
            Header: "Client Priority",
            accessor: "Priority",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Priority colors
                const priorityColor = data?.priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data?.priority === "0" || data?.priority === "1" || data?.priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"

                                }}
                            >
                                {data?.priority === "0" ? "Low" : data?.priority === "1" ? "Medium" : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },
        {
            Header: "UDS Criticality",

            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;

                // Sub-category priority colors
                const priorityColor = data?.clientsub_category_id?.Priority === "0"
                    ? "hsla(43, 100%, 50%, 1)" // Low
                    : data?.clientsub_category_id?.Priority === "1"
                        ? "hsla(32, 92%, 59%, 1)" // Medium
                        : data?.clientsub_category_id?.Priority === "2"
                            ? "hsla(7, 85%, 58%, 1)" // High
                            : "";

                return (
                    <span className="PriorityColumns">
                        {data.clientsub_category_id?.Priority === "0" || data.clientsub_category_id?.Priority === "1" || data.clientsub_category_id?.Priority === "2" ? (
                            <button
                                style={{
                                    backgroundColor: priorityColor,
                                    border: "none",
                                    color: "#fff", // Text color remains white for readability
                                    padding: "5px 10px",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                    width: "97px"
                                }}
                            >
                                {data.clientsub_category_id?.Priority === "0"
                                    ? "Low"
                                    : data.clientsub_category_id?.Priority === "1"
                                        ? "Medium"
                                        : "High"}
                            </button>
                        ) : (
                            "---"
                        )}
                    </span>
                );
            },
        },



        {
            Header: "Status",
            accessor: "",
            Cell: ({ cell }) => {
                let data = cell.row.original;
                return (
                    <div className="TicketButtons">

                        <>
                            <button className='Buttonstatus'
                                style={{
                                    background: data.status == 0 ? "#FDEDE9" : // Open - light background
                                        data.status == 1 ? "#FFF8E5" : // In Progress - yellow background
                                            data.status == 2 ? "#E7F8ED" : // Completed - light green background
                                                data.status == 3 ? "#DFFFE3" : // Close - light green background for Close
                                                    "#FFDDDD", // Default for Reopen - light red background
                                    color: data.status == 0 ? "#ED4C28" : // Open - red text
                                        data.status == 1 ? "#FFB800" : // In Progress - yellow text
                                            data.status == 2 ? "#12B749" : // Completed - green text
                                                data.status == 3 ? "#8BC34A" : // Close - light green text for Close
                                                    "#ED4C28", // Default for Reopen - red text
                                }}
                            >
                                {data.status == 0 ? "Open" :
                                    data.status == 1 ? "In Progress" :
                                        data.status == 2 ? "Review" :
                                            data.status == 3 ? "Resolved" : "Reopened"}


                            </button>

                        </>

                    </div>
                );
            },
        },



    ];

    const ClearState = (Counts) => {
        if (Counts == 2) {
            SetSelectval({
                ...selectVal,
                status: "",
            });
            setstatustcket({ value: "", label: "All" })

            dispatch(setTheTicketingsystemStatusState({ value: "", label: "All" }));
            setdtPageindex(1);
        }
    };

    //--------_____Filter-----------Based---On----Status--
    const count = (Counts, values, sel, SelectedValues) => {
        setdtPageindex(1);
        setSelected(sel);
        SetStates(true);
        console.log(SelectedValues, sel, "we[ouoieqpwo[epqowepoqw[epopewopowieoiqwue");
        setstatustcket(SelectedValues)
        SetSelectval({
            ///Completed
            ...selectVal,

            status: sel,
        });

        dispatch(setTheTicketingsystemStatusState(SelectedValues));




    };



    const handleNext = (next) => {
        setdtPageindex(next + 1);
    };

    const GotoEnteredPage = (gotopage) => {
        setdtPageindex(gotopage)
    }

    const handlePrevious = (previous) => {
        if (previous != 0) {
            setdtPageindex(previous);

        }
    };

    const openMe = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('left', '897.34px !important', 'important');
            rsAnimFade.style.setProperty('top', '197.109px', 'important');
        }
    }

    const CloseDateRange = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('display', 'none', 'important');
        }
    }
    const HandleTicketViewparts = (data) => {
        dispatch(settheTicketIDSActions(data.id)); /// ticket id
        navigate("/ticketviews")
    }
    useEffect(() => {
        dispatch(settheTicketraiseroutes(2))
    }, [])


    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        <h3>Tickets</h3>

                    </div>
                    <div className="createticketing col-sm-5">
                        <button
                            style={{ zIndex: "555" }}
                            onClick={(e) => {
                                dispatch(settheTicketSuccesspopuos(false))

                                // setRoleCreatePopup(true);
                                // setEditID("");
                                // dispatch(settheTicketViewIds(""))
                                navigate("/client_ticket")
                            }}
                            className="Createbutton"
                        >
                            Raise a Ticket
                        </button>
                    </div>


                </div>


                <div
                    className="row Filters"
                    style={{
                        padding: "29px 28px 57px",
                        margin: "0px",
                        position: "relative",
                        zIndex: "90",

                        marginLeft: "0px",
                        marginRight: "0px",
                        top: "-17px",
                    }}
                >
                    <div
                        className="col-sm-2"
                        style={{ marginTop: "-19px", zIndex: "99" }}
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => {
                                setMuliselect(e);
                            }}
                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                                console.log(e, "jjk9090");
                            }}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect3(e);
                                console.log(e, "jjk9090");
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>

                    <div
                        className="col-sm-2"
                        style={{ zIndex: "20", marginTop: "-19px" }}
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Client 
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}

                            onChange={(e) => {
                                setdtPageindex(1);
                                HandleClientBranches(e);
                            }}
                            options={Optionsbranch}
                            labelledBy="Select"
                            onInputChange={HandleInputBranch}
                            isClearable={true}

                            value={mulitibranch}
                        />
                    </div>



                    <div className="col-2 SelectedDates seleceteddatedTickets" style={{ marginTop: "-21px" }} >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ width: "100%", textAlign: "left" }}
                        >
                            Select Date
                            <span style={{ color: "red" }}>*</span>

                        </label>


                        <div className="datepicker_dash" style={{ marginRight: "-15px" }}>
                            <DateRangePicker

                                defaultValue={
                                    state.StateManagementOverallCall.TicketingsystemRange1 == ""
                                        ? [
                                            // new Date(
                                            //     state.StateManagementOverallCall.TicketingsystemRange1
                                            // ),
                                            // new Date(
                                            //     state.StateManagementOverallCall.TicketingsystemRange2
                                            // ),
                                            // "", ""
                                            new Date(range[0]), new Date(range[1])
                                        ]
                                        : [
                                            new Date(
                                                state.StateManagementOverallCall.TicketingsystemRange1
                                            ),
                                            new Date(
                                                state.StateManagementOverallCall.TicketingsystemRange2
                                            ),
                                        ]
                                }
                                // value={
                                //     [
                                //         new Date(
                                //             state.StateManagementOverallCall.TicketingsystemRange1
                                //         ),
                                //         new Date(
                                //             state.StateManagementOverallCall.TicketingsystemRange2
                                //         ),
                                //     ]
                                // }

                                onOpen={() => {
                                    openMe()
                                }}
                                onClose={() => {
                                    CloseDateRange()
                                }}
                                disabledDate={(date) => isAfter(date, new Date())}
                                editable={false}
                                appearance="default"
                                placement="bottomEnd"
                                size="lg"
                                ranges={predefinedBottomRanges}
                                placeholder="From - To"
                                // style={{ width: 300, padding: 10 }}
                                onClean={(e) => cleaningrange(e)}
                                onChange={(e) => {
                                    if (e != null && e.length === 2) {
                                        const [startDate, endDate] = e;
                                        const diffDays = differenceInDays(endDate, startDate);
                                        // if (diffDays === 30) {
                                        //     // Since we are using inclusive range, difference should be 30 for 31 days
                                        //     setrange([]);
                                        //     e.forEach((newValue) => {
                                        //         const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                                        //         const localISOTime = new Date(newValue - tzoffset)
                                        //             .toISOString()
                                        //             .slice(0, -1);
                                        //         handlechangedate(localISOTime);
                                        //     });
                                        // } else if (diffDays < 30) {
                                        //     setrange([]);
                                        //     e.forEach((newValue) => {
                                        //         const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                                        //         const localISOTime = new Date(newValue - tzoffset)
                                        //             .toISOString()
                                        //             .slice(0, -1);
                                        //         handlechangedate(localISOTime);
                                        //     });
                                        // } else {
                                        //     setrange([]);
                                        //     e.forEach((newValue) => {
                                        //         const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                                        //         const localISOTime = new Date(newValue - tzoffset)
                                        //             .toISOString()
                                        //             .slice(0, -1);
                                        //         handlechangedate(localISOTime);
                                        //     });

                                        //     // toast.error("Please select a range of exactly 31 days.", {
                                        //     //     position: toast.POSITION.TOP_RIGHT,
                                        //     // });
                                        // }

                                        setrange([]);
                                        e.forEach((newValue) => {
                                            const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                                            const localISOTime = new Date(newValue - tzoffset)
                                                .toISOString()
                                                .slice(0, -1);
                                            handlechangedate(localISOTime);
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>

                </div>


                <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
                    <ReactTable
                        data={state.TrackingrecordgetOfSystemList.TrackingReport}
                        columns={columns}
                        totalItems={state.TrackingrecordgetOfSystemList.Total_Count}
                        currentPage={currentPage}
                        onChange={tochange}
                        setCurrentPage={setCurrentPage}
                        pagesize={pagesize}

                        dtpagesize={pageSize}
                        dtpageindex={dtpageindex}
                        pageindex={pageindex}
                        onPrevious={handlePrevious}
                        onNextpage={handleNext}
                        GotoEnteredPage={GotoEnteredPage}

                        datacount={state.TrackingrecordgetOfSystemList.Total_Count}

                        // values={state.StateManagementOverallCall.TicketingsysttemStatusState}
                        values={StatusTicket}
                        options={optionsstatus}
                        ApproveRequestFilter={true}
                        Filter={Filter}
                        count={count}
                        ClearState={ClearState}
                        placeHold={place}

                        MakeCreate={true}
                        ViewParts={(e) => {
                            HandleTicketViewparts(e);
                        }}

                        PriorityKeys={true}
                        HandlethepriorityChanges={HandlethepriorityChanges}
                        priorityoptions={priorityoptions}
                        PriorityValues={PriorityValues}
                        Nodatarecord={"No Tickets Available"}
                        
            searchVal={TablePositionPersist?.Ticketing_listed?.search == "" || TablePositionPersist?.Ticketing_listed?.search ==undefined? "":TablePositionPersist.Ticketing_listed.search}
            search_key={true}


                    />

                </div>
            </div>

        </>
    );
};

export default TicketingList;
